import React, { Component } from 'react'
//import HKSTP_Night from '../images/Feelings_HKSTP_Night.jpeg'
//import HKSTP_Morning from '../images/Feelings_HKSTP.jpg'
import {
  generateSceneByGuest,
  getRandomScene,
  waitSceneMusic,
} from '../sdk/scene'
import './Home.css'
// @ts-ignore
import { Pannellum } from 'pannellum-react'
import { startMusic } from '../global/music'
import { later } from '@beenotung/tslib/async/wait'
import { getNextTime } from '../sdk/rate-limit'
import { SECOND } from '@beenotung/tslib/time'

type Props = {}

type State = {
  image_url: string
  music_url: string | null
  error: string | undefined
  skybox_style_id?: number
  style_text: string
  prompt: string
  is_generating_image: boolean
  is_generating_music: boolean
  has_touch: boolean
  next_time: number
}

class Scene extends Component<Props, State> {
  state: State = {
    image_url: '',
    music_url: '',
    error: '',
    skybox_style_id: 2,
    style_text: '',
    prompt: '',
    is_generating_image: false,
    is_generating_music: false,
    has_touch: false,
    next_time: 0,
  }
  password = ''
  styles = [
    {
      id: '44',
      name: '1960s Ethereal Fantasy',
    },
    {
      id: '13',
      name: 'Advanced (no style)',
    },
    {
      id: '3',
      name: 'Anime',
    },
    {
      id: '43',
      name: 'Art Mix',
    },
    {
      id: '29',
      name: 'Cartoon',
    },
    {
      id: '31',
      name: 'Claymation',
    },
    {
      id: '35',
      name: 'Cyberpunk',
    },
    {
      id: '5',
      name: 'Digital Painting',
    },
    {
      id: '11',
      name: 'Dreamlike',
    },
    {
      id: '17',
      name: 'Dutch Masters',
    },
    {
      id: '42',
      name: 'Enchanted Painting',
    },
    {
      id: '40',
      name: 'Epic Digital Painting',
    },
    {
      id: '2',
      name: 'Fantasy',
    },
    {
      id: '33',
      name: 'Holographic',
    },
    {
      id: '18',
      name: 'Infrared Photography',
    },
    {
      id: '15',
      name: 'Interiors',
    },
    {
      id: '20',
      name: 'Kids CGI Animation',
    },
    {
      id: '36',
      name: 'Low Poly Triangles',
    },
    {
      id: '19',
      name: 'Low Poly Voxels',
    },
    {
      id: '77',
      name: 'M3 Above the Clouds',
    },
    {
      id: '121',
      name: 'M3 Above the Clouds (Featured)',
    },
    {
      id: '83',
      name: 'M3 Advanced (artistic)',
    },
    {
      id: '112',
      name: 'M3 Advanced (photo/render)',
    },
    {
      id: '74',
      name: 'M3 Americana Painting',
    },
    {
      id: '81',
      name: 'M3 Anime',
    },
    {
      id: '85',
      name: 'M3 Comic',
    },
    {
      id: '87',
      name: 'M3 Digital Painting',
    },
    {
      id: '120',
      name: 'M3 Digital Painting (Featured)',
    },
    {
      id: '75',
      name: 'M3 Dutch Masters',
    },
    {
      id: '95',
      name: 'M3 Elegant Maximalism',
    },
    {
      id: '122',
      name: 'M3 Elegant Maximalism (Featured)',
    },
    {
      id: '104',
      name: 'M3 Grunge Pop',
    },
    {
      id: '90',
      name: 'M3 Neo Tokyo',
    },
    {
      id: '89',
      name: 'M3 Open World',
    },
    {
      id: '67',
      name: 'M3 Photoreal',
    },
    {
      id: '119',
      name: 'M3 Photoreal (Featured)',
    },
    {
      id: '115',
      name: 'M3 Playground',
    },
    {
      id: '123',
      name: 'M3 Playground (Featured)',
    },
    {
      id: '80',
      name: 'M3 Psychedelic Illustration',
    },
    {
      id: '88',
      name: 'M3 Retro Fantasy',
    },
    {
      id: '118',
      name: 'M3 Retro Fantasy (Featured)',
    },
    {
      id: '93',
      name: 'M3 Scifi Concept Art',
    },
    {
      id: '114',
      name: 'M3 Sky Dome',
    },
    {
      id: '73',
      name: 'M3 Storybook',
    },
    {
      id: '68',
      name: 'M3 UHD Render',
    },
    {
      id: '46',
      name: 'Mandala',
    },
    {
      id: '25',
      name: 'Manga',
    },
    {
      id: '26',
      name: 'Modern Interiors',
    },
    {
      id: '7',
      name: 'Nebula',
    },
    {
      id: '37',
      name: 'Netrunner',
    },
    {
      id: '24',
      name: 'Pen & Ink',
    },
    {
      id: '48',
      name: 'Psychedelic Illustration',
    },
    {
      id: '41',
      name: 'Radiant Painting',
    },
    {
      id: '6',
      name: 'Radiant Realism',
    },
    {
      id: '9',
      name: 'Realism',
    },
    {
      id: '10',
      name: 'SciFi',
    },
    {
      id: '16',
      name: 'Sky Dome',
    },
    {
      id: '30',
      name: 'Storybook',
    },
    {
      id: '34',
      name: 'Stylized CGI Realism',
    },
    {
      id: '4',
      name: 'Surreal',
    },
    {
      id: '23',
      name: 'Technical Drawing',
    },
    {
      id: '32',
      name: 'Vibrant Watercolor',
    },
    {
      id: '22',
      name: 'Watercolor',
    },
    {
      id: '47',
      name: 'Whimsical World',
    },
  ]
  componentDidMount(): void {
    this.loadImage()
    getNextTime({}).then(json => {
      this.setNextTime(json.next_time)
    })
  }
  loadImage = async () => {
    try {
      let json = await getRandomScene({})
      this.update({
        image_url: json.image_url,
        music_url: json.music_url,
        error: json.error,
      })
    } catch (error) {
      this.update({ error: String(error) })
    }
  }
  generate = async () => {
    try {
      let skybox_style_id = +this.styles.find(
        style => style.name === this.state.style_text,
      )?.id!
      if (!skybox_style_id) {
        throw new Error('Please select a style')
      }
      let prompt = this.state.prompt
      if (!prompt) {
        throw new Error('Please input a prompt')
      }
      this.update({
        is_generating_image: true,
        is_generating_music: true,
      })
      let json = await generateSceneByGuest({
        body: {
          prompt,
          skybox_style_id,
          music_style: this.state.style_text,
        },
      })
      if (json.error) {
        this.update({
          error: json.error,
          is_generating_image: false,
          is_generating_music: false,
        })
        return
      }
      this.setNextTime(json.next_time)
      if (!json.scene) {
        this.update({
          error: '',
          is_generating_image: false,
          is_generating_music: false,
        })
        return
      }
      let scene = json.scene
      this.update({
        image_url: scene.image_url,
        music_url: scene.music_url,
        error: json.error,
        is_generating_image: false,
      })
      let { scene_id } = scene
      while (true) {
        let json = await waitSceneMusic({ params: { scene_id } })
        if (!json.music_url) {
          await later(1000)
          continue
        }
        this.update({
          music_url: json.music_url,
          is_generating_music: false,
        })
        break
      }
    } catch (error) {
      console.log('cannot generate scene:', error)
      this.update({
        error: String(error),
        is_generating_image: false,
        is_generating_music: false,
      })
    }
  }

  update(state: Partial<State>) {
    if (state.error) {
      // TODO use sweetalert
      alert(state.error)
    }
    if (
      (state.music_url && this.state.has_touch) ||
      (this.state.music_url && state.has_touch)
    ) {
      setTimeout(startMusic)
    }
    this.setState(state as State)
  }

  markHasTouch = () => {
    if (!this.state.has_touch) {
      this.update({ has_touch: true })
    }
  }

  nextTimeInterval?: ReturnType<typeof setInterval>

  setNextTime(next_time: number) {
    this.update({ next_time })
    if (this.nextTimeInterval) {
      clearInterval(this.nextTimeInterval)
      this.nextTimeInterval = undefined
    }
    if (next_time <= Date.now()) return
    this.nextTimeInterval = setInterval(() => {
      this.forceUpdate()
    }, 100)
  }

  renderGenerateButton() {
    let interval = this.state.next_time - Date.now()
    let disabled = this.state.is_generating_image || interval > 0
    return (
      <button
        disabled={disabled}
        onClick={this.generate}
        className="prompt-button"
      >
        {this.state.is_generating_image
          ? 'Generating Scene...'
          : this.state.is_generating_music
          ? 'Generating Music...'
          : interval > 0
          ? `Generate (wait ${(interval / SECOND).toFixed(1)} seconds)`
          : 'Generate'}
      </button>
    )
  }

  render() {
    let music_url = this.state.music_url || ''
    return (
      <>
        <div className="header">
          <audio
            hidden
            controls
            autoPlay
            loop
            src={music_url}
            ref={audio => {
              if (audio) {
                window.addEventListener('touchstart', this.markHasTouch, {
                  once: true,
                })
                window.addEventListener('mousedown', this.markHasTouch, {
                  once: true,
                })
              }
            }}
          />
          <Pannellum
            width="100vw"
            height="100vh"
            image={this.state.image_url}
            yaw={300}
            hfov={110}
            autoLoad
            autoRotate={-5}
            compass={true}
            showZoomCtrl={false}
            mouseZoom={false}
            onLoad={() => {
              console.log('panorama loaded')
            }}
          >
            <Pannellum.Hotspot
              type="custom"
              pitch={-10}
              yaw={-120}
              handleClick={(evt: MouseEvent, args: any) => this.loadImage()}
            />
          </Pannellum>

          <div className="container">
            <div className="upper-section">
              <input
                type="text"
                value={this.state.prompt}
                onChange={e => this.update({ prompt: e.target.value })}
                name="prompt"
                placeholder="Enter your prompt here: "
                className="input-text"
                autoComplete="prompt"
                style={{ color: 'white' }}
              />
              <button
                onClick={() => this.update({ prompt: '' })}
                className="clear-button"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  className="icon"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="m15 9-6 6"></path>
                  <path d="m9 9 6 6"></path>
                </svg>
              </button>
            </div>
            <div className="line"></div>
            <div className="lower-section">
              <input
                hidden
                type="password"
                name="password"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  (this.password = e.target.value)
                }
                placeholder="Password: "
                className="input-password"
                style={{ color: 'white' }}
              />
              {/* combobox for style / theme */}
              <input
                placeholder="Select a style:"
                className="input-text"
                list="styleList"
                value={this.state.style_text}
                onChange={e =>
                  this.update({
                    style_text: e.target.value,
                    skybox_style_id:
                      +this.styles.find(style => style.name === e.target.value)
                        ?.id! || this.state.skybox_style_id,
                  })
                }
                style={{ backgroundColor: 'transparent', color: 'white' }}
              />
              <datalist id="styleList">
                {this.styles.map(style => (
                  <option>{style.name}</option>
                ))}
              </datalist>
              <select
                hidden
                className="model-styles"
                value={this.state.skybox_style_id}
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                  this.update({ skybox_style_id: Number(e.target.value) })
                }
              >
                {this.styles.map(style => (
                  <option value={style.id}>{style.name}</option>
                ))}
              </select>
              {this.renderGenerateButton()}
            </div>
          </div>
        </div>
      </>
    )
  }
}

function Home() {
  return (
    <div className="h-screen flex">
      <Scene />
    </div>
  )
}

export default Home
